import React from "react";
import { Link } from "react-router-dom";
import Sam from '../../assest/background/Sam.png';
import Dave from '../../assest/background/Dave.png';
function InvestRealState7() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-InvestRealState1">
      <div data-aos="fade-center" className="container-fluid row   vh-100 w-100">
      <div className="col-sm-3 d-flex  align-items-center justify-content-center ">
        <img src={Dave} className="DaveImage" alt="Dave" />
        </div>
            <div className="col-sm-6 d-flex flex-column align-items-end justify-content-end my-auto text-center">
                <div className="bg-white rounded-border p-4   border border-4 border-dark">
                  <p className="py-1">One of the friends made a decision that will negatively impact the rest of his life.</p>
                  <p className="py-1">The other friend made a different decision that will significantly increase his wealth.</p>
                   <p className="py-1">Which one do you believe made the better decision?</p>
                  <Link to={'/investing-in-real-estate/eighth-step'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div>
            </div>
            <div className="col-sm-3 d-flex  align-items-center justify-content-center position-relative">
            <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
            <img src={Sam} className="SamImage" alt="Sam" /></div>
        </div>
      </div>
    </>
  );
}

export default InvestRealState7;
